export default __webpack_public_path__ + "static/media/OpenJApp_1.90f99337.png";